import { render, staticRenderFns } from "./SummaryLocation.vue?vue&type=template&id=c6c8ff60&scoped=true&"
import script from "./SummaryLocation.vue?vue&type=script&lang=js&"
export * from "./SummaryLocation.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLocation.vue?vue&type=style&index=0&id=c6c8ff60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c8ff60",
  null
  
)

export default component.exports